import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, useFormField, TextField } from '@frontend/design-system';

interface ReceiptSectionProps {
  emailFieldProps: ReturnType<typeof useFormField<'email'>>;
  personEmail: string | undefined;
}

/**
 * @deprecated /collect-payment/* will be removed once /collect-payment-multi/ is fully live.
 */
export const ReceiptSection = ({ emailFieldProps, personEmail }: ReceiptSectionProps) => {
  const { t } = useTranslation('payments');

  const fieldTitle = personEmail ? (
    <Trans t={t}>
      Receipt emailed to <b>{personEmail}</b>. You can send another receipt to an additional email address here
    </Trans>
  ) : (
    t('Send a receipt to this email')
  );
  const fieldLabel = personEmail ? t('Additional Email') : t('Email');

  return (
    <div
      css={css`
        width: 380px;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing(1)};
        margin-top: ${theme.spacing(2)};
      `}
    >
      <Text size='large'>{fieldTitle}:</Text>
      <TextField {...emailFieldProps} name='email' label={fieldLabel} />
    </div>
  );
};
